import { common as kaCommon } from './ka/common';
import { common as enCommon } from './en/common';

const messages = {
  ka: {
    common: kaCommon,
  },
  en: {
    common: enCommon,
  },
};

export default messages;
